import { ChangeDetectorRef, Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { ApiService } from 'src/app/services/api.service';
import { CoreService } from 'src/app/services/core.service';
import { LoaderService } from 'src/app/services/loader.service';
import { CartStorage } from 'src/app/storage/cart';

@Component({
  selector: 'app-promo-t5',
  templateUrl: './promo-t5.component.html',
  styleUrls: ['./promo-t5.component.scss']
})
export class PromoT5Component {
  defImgProd:string = "assets/img/logo_nina_placeholder.jpg"
  products: any = [];
  gifts: any = [];
  dataPromo: any = null;
  dataBranch: any = null;
  promo:string = "";
  selectedProductData:any = null;
  selectedProductGiftData:any = null;
  stepOne:boolean = true;
  stepTwo:boolean = false;
  btnDisabled:boolean = true;

  constructor(private cdr: ChangeDetectorRef, private loaderService:LoaderService, private coreService:CoreService, public apiServices: ApiService, public cookies: CookieService, public route: ActivatedRoute, public router: Router){
      if(this.cookies.check('DataPromo') && (this.cookies.check('Branch') || this.cookies.check('BranchTemp'))){
        this.dataPromo = JSON.parse(this.cookies.get('DataPromo'))
        if(this.cookies.check('Branch')){
          this.dataBranch = JSON.parse(this.cookies.get('Branch'))
        }
        else if(this.cookies.check('BranchTemp')){
          this.dataBranch = JSON.parse(this.cookies.get('BranchTemp'))
        }
        else{
          this.coreService.emitSubjet.next({ type: 'Snackbar', payload: {text: "No se encontraron datos de la sucursal"} });
          this.router.navigate(['/promotions'])
        }
        this.getProducts()
        this.getRegalos()
      }
      else{
        this.coreService.emitSubjet.next({ type: 'Snackbar', payload: {text: "No se encontraron datos de la promoción"} });
        this.router.navigate(['/promotions'])
      }
    }
  
    ngOnInit(): void {
  
    }
  
    getProducts(){
      let data = { token: this.cookies.get('Token'), idSucursal:this.dataBranch.idSucursal, idOferta: this.dataPromo.idPromo, idCliente: this.dataPromo.idCliente }
      this.loaderService.show()
      this.apiServices.getProductosPromoREPorSucursal(data).subscribe({
        next: (value) => {
          this.promo = value.tituloPromocion
          this.products = value.listaDeProductos;
          if(value.listaDeProductos.length === 0){
            this.coreService.emitSubjet.next({ type: 'Snackbar', payload: {text: "Esta promoción no esta disponible el día de hoy, pero puedes disfrutar otras disponibles"} });
            this.router.navigate(['/promotions'])
            return;
          }
          this.products.forEach((product:any) => {
            product.selected = false;
          });
          this.loaderService.hide()
          this.cdr.detectChanges();},
        error: (err) => {
          this.loaderService.hide()
        }
      })
    }

    getRegalos(){
      let data = { token: this.cookies.get('Token'), idSucursal:this.dataBranch.idSucursal, idOferta: this.dataPromo.idPromo, idCliente: this.dataPromo.idCliente }
      this.loaderService.show()
      this.apiServices.getProductosPromoREPorSucursalLista(data).subscribe({
        next: (value) => {
          this.promo = value.tituloPromocion
          this.gifts = value.listaDeProductos;
          this.gifts.forEach((gift:any) => {
            gift.selected = false;
          });
          this.loaderService.hide()
          this.cdr.detectChanges();},
        error: (err) => {
          this.loaderService.hide()
        }
      })
    }
  
    selectedProduct(product:any){
      if(this.selectedProductData != null){
        this.selectedProductData.selected = false;
      }
      this.selectedProductData = product;
      this.selectedProductData.selected = true;
    }

    selectedProductGift(gift:any){
      if(this.selectedProductGiftData != null){
        this.selectedProductGiftData.selected = false;
      }
      this.selectedProductGiftData = gift;
      this.selectedProductGiftData.selected = true;
      this.btnDisabled = false;
    }
  
    continuar(){
      if(this.selectedProductData != null){
        this.stepOne = false;
        this.stepTwo = true;
      }
      else{
        this.coreService.emitSubjet.next({ type: 'Snackbar', payload: {text: "Selecciona un producto para canjear la promoción"} });
      }
    }
  
    finalizar(){
      this.btnDisabled = true;
      let cartPromo = []
      if(CartStorage.exists()){
        cartPromo = CartStorage.getCart()
      }
      this.selectedProductData.qty = 1
      this.selectedProductData.promo = true
      this.selectedProductData.idPromo = this.dataPromo.idPromo
      this.selectedProductData.tipo = 5
      this.selectedProductData.married = new Date().getTime()
      this.selectedProductGiftData.qty = 1
      this.selectedProductGiftData.promo = true
      this.selectedProductGiftData.idPromo = this.dataPromo.idPromo
      this.selectedProductGiftData.tipo = 5
      this.selectedProductGiftData.married = this.selectedProductData.married
      cartPromo.push(this.selectedProductData)
      cartPromo.push(this.selectedProductGiftData)
      const tomorrow = new Date();
      tomorrow.setHours(0, 0, 0, 0);
      tomorrow.setDate(tomorrow.getDate() + 1);
      CartStorage.saveCart(cartPromo)
      if(!this.cookies.check('Branch')){
        this.cookies.set('Branch', JSON.stringify(this.dataBranch), {expires: tomorrow, sameSite: 'Strict'})
        if(this.cookies.check('BranchTemp')){
          this.cookies.delete('BranchTemp', '/');
        }
      }
      this.coreService.emitSubjet.next({ type: 'Cart', payload: null});
      setTimeout(() => {
        this.router.navigate(['/cart'])
      }, 1500)
    }
}
